import { useNavigate } from "react-router-dom";
import { ClinicianDashboardView } from "@/features/clinician/review-queue/components/ClinicianDashboardView";

export function ClinicianDashboardPage() {
  const navigate = useNavigate();
  return (
    <ClinicianDashboardView
      onOpenItem={(id) => navigate(`/clinician/review/${encodeURIComponent(id)}`)}
      onPreviewItem={(id) => navigate(`/clinician/queue/${encodeURIComponent(id)}`)}
    />
  );
}
